import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {Store} from '@ngrx/store';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {buildFormGroup} from '@aviary/forms/form.helpers';
import {isPopulatedString} from '@aviary/store/common/typing.helpers';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {FALLBACK_EMAIL_VERIFICATION_VALUE} from '@store/registration/registration.fallback';
import {RegistrationActions} from '@store/registration/registration.actions';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {RegistrationValidators} from '@store/registration/registration.validators';
import {MatError} from '@angular/material/input';
import {NgOptimizedImage} from '@angular/common';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {VERIFICATION_EMAIL_RESEND_COOLDOWN_MS} from '@store/registration/registration.types';

@Component({
  selector: 'px-registration-verify-email-form',
  host: {
    class: 'flex flex-row gap-4 items-center justify-center md:justify-between lg:pl-10 lg:pr-20'
  },
  templateUrl: './registration-verify-email-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InputFormFieldComponent, SelectPipe, MatCardContent, MatCard, MatError, NgOptimizedImage, FilledButtonComponent, TextButtonComponent]
})
export class RegistrationVerifyEmailFormComponent {
  public readonly verifyForm: ExtendedFormGroup = buildFormGroup(FALLBACK_EMAIL_VERIFICATION_VALUE, inject(RegistrationValidators).verifyEmail);
  public readonly store = inject(Store);
  public readonly selectors = RegistrationSelectors.Registration;
  public readonly viewportSelectors = ViewportSelectors;
  public recentlySent = false;
  private readonly changeDetector: ChangeDetectorRef = inject(ChangeDetectorRef);

  public onClickResend() {
    if (this.recentlySent) {
      return;
    }
    this.recentlySent = true;
    this.store.dispatch(RegistrationActions.requestVerificationEmail());
    setTimeout(() => {
      this.recentlySent = false;
      this.changeDetector.markForCheck();
    }, VERIFICATION_EMAIL_RESEND_COOLDOWN_MS);
  }

  public onClickNext() {
    const code = this.verifyForm.value.verificationCode;
    if (isPopulatedString(code)) {
      this.store.dispatch(RegistrationActions.verifyEmail(code));
    }
  }
}
